import React, { Component } from 'react';
import { Badge, Button, Col, FormGroup, Input, Row, Collapse, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FilterContactsCard, FilterPaymentCard, FilterStatusCard, FilterInvoiceCard, FilterDateCard } from './FilterCard';
import './styles.scss'

export default class Filters extends Component {
  state = {
    isFiltersShowing: false
  };

  toggleFilters = () => {
    this.setState({
      isFiltersShowing: !this.state.isFiltersShowing
    });
  };

  render() {
    return (
      <>
        <Row>
          <Col xs>
            <Button onClick={() => this.toggleFilters()}
                    active={this.state.isFiltersShowing}
                    outline
                    color="secondary"
                    className="float-left">
              Фильтры <Badge pill>1</Badge>
            </Button>

            <FormGroup className="float-left" style={{ width: '231px', marginLeft: '5px', marginRight: '10px' }}>
              <Input type="text" name="search" id="exampleEmail" placeholder="Поиск"/>
            </FormGroup>

            <UncontrolledButtonDropdown>
              <DropdownToggle color="primary" caret>
                Выбрано: 8
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>Запросить выплату</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Отменить выделение</DropdownItem>
                <DropdownItem>Удалить</DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </Col>
        </Row>
        <Row>
          <Col xs>
            <Collapse className="filters" isOpen={this.state.isFiltersShowing}>
              <FilterContactsCard/>
              <FilterPaymentCard/>
              <FilterStatusCard/>
              <FilterInvoiceCard/>
              <FilterDateCard/>
            </Collapse>
          </Col>
        </Row>
      </>
    );
  }
}
